// File: src/utils/errorReporter.js
// OOOSH Driver Verification - Client-Side Error Reporter
// Lightweight utility to send error reports to the logging backend
// 
// Every report goes to OP via log-client-error (kept in hire_form_error_events).
//   'critical' — app crash, unrecoverable error → also emails info@
//   'warning'  — recoverable error, user can retry → kept in OP only
//   'info'     — for the record → kept in OP only
//
// Usage:
//   import reportError from './utils/errorReporter';
//   reportError({ page: 'DVLAPreviewPage', error: err.message, severity: 'warning' });

const reportError = async ({ page, error, severity = 'warning', email = null, additionalInfo = null }) => {
  try {
    // Try to get email from sessionStorage if not provided
    const driverEmail = email || sessionStorage.getItem('sessionDriverEmail') || 'unknown';
    
    await fetch('/.netlify/functions/log-client-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page,
        error: typeof error === 'string' ? error : String(error),
        severity,
        email: driverEmail,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        url: window.location.href,
        additionalInfo: additionalInfo || null
      })
    }); 
    
    console.log(`📝 Error reported (${severity}):`, error);
  } catch (e) {
    // Error reporting should NEVER break the app
    // If this fails, just log to console and move on
    console.error('Failed to report error (non-critical):', e);
  }
};

export default reportError; 